import {Box} from '@mui/material';
import {FC, useEffect, useState} from 'react';

import {ReactComponent as PauseIcon} from '../../../../../assets/images/pause-icon.svg';
import './DocThumbnailSizeControl.scss';

type DocThumbnailSizeControlProps = {
  currentSize: ThumbnailSize;
  onSizeChange: (newSize: ThumbnailSize) => void;
};
export type ThumbnailSize = 'small' | 'medium' | 'large';
const DocThumbnailSizeControl: FC<DocThumbnailSizeControlProps> = ({
  currentSize,
  onSizeChange,
}) => {
  const [activeSize, setActiveSize] = useState<ThumbnailSize>('large');
  const activeControlIcon = (
    <Box className="control-selected-icon">
      <PauseIcon />
    </Box>
  );

  const onSizeChangeHandler = (selectedSize: ThumbnailSize) => {
    if (selectedSize == activeSize) return;
    setActiveSize(selectedSize);
    onSizeChange?.(selectedSize);
  };

  useEffect(() => {
    setActiveSize(currentSize);
  }, [currentSize]);
  return (
    <Box
      data-testid="thumbnail-size-control"
      className="doc-thumbnail-size-control"
      display="flex"
      flexDirection="row"
    >
      <Box className="control-container" flex={1}>
        <Box
          data-testid="thumbnail-small"
          className="control-component"
          onClick={() => onSizeChangeHandler('small')}
        >
          {activeSize == 'small' ? (
            activeControlIcon
          ) : (
            <Box className="control-unselected-icon" />
          )}

          <Box className="control-line" />
        </Box>

        <Box
          data-testid="thumbnail-medium"
          className="control-component"
          onClick={() => onSizeChangeHandler('medium')}
        >
          <Box className="control-line" />
          {activeSize == 'medium' ? (
            activeControlIcon
          ) : (
            <Box className="control-unselected-icon" />
          )}

          <Box className="control-line" />
        </Box>
        <Box
          data-testid="thumbnail-large"
          className="control-component"
          onClick={() => onSizeChangeHandler('large')}
        >
          <Box className="control-line" />
          {activeSize == 'large' ? (
            activeControlIcon
          ) : (
            <Box className="control-unselected-icon" />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default DocThumbnailSizeControl;
